import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import { useApi, useUser } from "../../../context/api.js";
import {
  setSelectedHomework,
  useHomework,
  setMilestoneValidation,
  editHomework,
} from "../../../context/homework";
import MDTypography from "../../../components/MDTypography";
import MDBox from "../../../components/MDBox";
import HomeworkMilestone from "../../../components/HomeworkMilestone";
import HomeworkCategoryLabel from "../../../components/HomeworkCategoryLabel";
import { pad } from "../../../utils/pad.js";
import { formatDate } from "../../../utils/date.js";
import { useH } from "../../../context/homework/homework-selectors.js";

function HomeworkDialog() {
  const [homework, dispatch] = useHomework();
  const user = useUser();
  const [validation, setValidation] = useState(null);
  const h = useH(homework.selectedHomework, homework.selectedHomeworkFrom);

  const d = new Date();
  const today = d.getFullYear() + "-" + pad(d.getMonth() + 1) + "-" + pad(d.getDate());

  return (
    <Dialog
      open={!!homework.selectedHomework}
      onClose={() => setSelectedHomework(dispatch, null)}
      maxWidth="md"
      fullWidth
    >
      {!h && (
        <DialogContent sx={{ textAlign: "center" }}>
          <CircularProgress color="info" />
        </DialogContent>
      )}
      {!!h && (
        <>
          {/*<DialogTitle>{h.name}</DialogTitle>*/}
          <DialogContent>
            {/*<DialogContentText>{h.description}</DialogContentText>*/}
            <MDTypography sx={{ fontSize: 14 }} color="text" gutterBottom component="div">
              {h.type.name} -{" "}
              <HomeworkCategoryLabel name={h.category.name} color={h.category.color} />
            </MDTypography>
            <MDTypography variant="h5" component="div">
              {h.name}
            </MDTypography>
            {h.list && (
              <MDTypography
                sx={{
                  mb: 1.5,
                  fontStyle: "italic",
                  fontSize: 12,
                  color: new Date(h.list.end + "T23:59:59") <= new Date() ? "red" : undefined,
                }}
                color="text"
              >
                Jusqu&apos;au {formatDate(h.list.end)}
              </MDTypography>
            )}
            {h.description && <MDTypography variant="body2">{h.description}</MDTypography>}
            {h.validation !== "none" && (
              <>
                <MDTypography
                  style={{ fontStyle: "italic", textAlign: "center" }}
                  variant="caption"
                  component="div"
                  mt={2}
                >
                  {!validation && "Sélectionne une étape pour en commencer la validation !"}
                  {validation === "disabled" &&
                    "Validation désactivée : reviens plus tard pour valider cette étape !"}
                  {validation &&
                    validation.startsWith("submitted-") &&
                    "Étape soumise le " +
                      formatDate(validation.substring(10)) +
                      ", attendons maintenant que ton parent la valide !"}
                  {validation &&
                    validation.startsWith("validated-") &&
                    "Étape validée le " + formatDate(validation.substring(10)) + " ! Bravo !"}
                  {validation === "manual" &&
                    "Validation manuelle : tu peux envoyer une demande de validation à ton parent dès que tu es prêt !"}
                  {validation === "parent" &&
                    "Validation parentale : ton parent validera cette étape pour toi directement."}
                  {validation === "autonomous" &&
                    "Validation autonome : valide ton étape toi-même quand tu l'auras terminée."}
                  {validation === "activity" &&
                    "Valide cette étape en terminant l'activité proposée !"}
                </MDTypography>
                <MDBox display="flex" alignItems="center" justifyContent="center">
                  {(h.milestones || []).map((m) => {
                    const disabled =
                      user.type === "student" &&
                      h.validation === "daily" &&
                      !m.submitted &&
                      (h.milestones.find(
                        (o) => (o.submission_date || "").split(" ")[0] === today
                      ) ||
                        h.milestones.find((o) => !o.submitted) !== m);

                    return (
                      <HomeworkMilestone
                        key={m.id}
                        {...m}
                        size={48}
                        disabled={disabled}
                        onMouseEnter={() =>
                          setValidation(
                            disabled
                              ? "disabled"
                              : m.done
                              ? "validated-" + m.validation_date
                              : m.submitted
                              ? "submitted-" + m.submission_date
                              : m.validation_mode
                          )
                        }
                        onMouseLeave={() => setValidation(null)}
                        onClick={
                          user.type === "student" && (m.submitted || m.done)
                            ? undefined
                            : () =>
                                setMilestoneValidation(
                                  dispatch,
                                  m.id,
                                  homework.selectedHomeworkFrom
                                )
                        }
                      />
                    );
                  })}
                </MDBox>
              </>
            )}
          </DialogContent>
          {/*<DialogActions>*/}
          {/*  <Button disabled={!h} onClick={() => setSelectedHomework(dispatch, null)}>*/}
          {/*    Fermer*/}
          {/*  </Button>*/}
          {/*</DialogActions>*/}
        </>
      )}
      <IconButton
        aria-label="close"
        onClick={() => setSelectedHomework(dispatch, null)}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      {!!h && (user.type === "parent" || user.type === "admin") && (
        <IconButton
          aria-label="edit"
          onClick={() => {
            setSelectedHomework(dispatch, null);
            editHomework(dispatch, h.id, homework.selectedHomeworkFrom);
          }}
          sx={{
            position: "absolute",
            right: 56,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <EditIcon />
        </IconButton>
      )}
    </Dialog>
  );
}

export default HomeworkDialog;
